import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UploadService } from '../../services/upload.service';
import { Order } from '../../models/order.model';
import { ProductOrder } from '../../models/product-order.model';

@Component({
    selector: 'app-print-labels',
    templateUrl: './print-labels.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintLabelsComponent implements OnChanges {
  @Input() order: Order;
  @Output() printed = new EventEmitter<void>();
  public productImages: { [key: string]: string } = {};
  private placeHolderUri = './assets/images/okto_placeholder.png';
  public elRef: ElementRef

  constructor(private uploadService: UploadService, elRef: ElementRef) {
    this.elRef = elRef;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.order.isFirstChange() || !changes.order.currentValue) {
      return;
    }
    this.print().then(() => {
      setTimeout(() => {
        this.printed.emit(this.elRef.nativeElement.innerHTML);
      }, 0);
    });
  }

  private async print(): Promise<void> {
    this.productImages = {};
    for (const product of this.order.products) {
      if (!product.poFiles || !product.poFiles.length) {
        this.productImages[product.poId] = this.placeHolderUri;
      } else {
        this.productImages[product.poId] = await this.getThumbnail(product);
      }
    }
  }

  private getThumbnail(product: ProductOrder): Promise<string> {
    const path = product.poFiles[0].path.replace('.pdf', '-bat-image.jpg');
    return this.uploadService.getFileUrl(path)
      .then(res => res ? res : this.placeHolderUri)
      // Return a 1px transparent image
      .catch(err => {
        console.error(err);
        return this.placeHolderUri;
      });
  }
}
